
export enum JurisdicaoLocalAbrangencia {
  ESTADUAL   =  'ESTADUAL',
  LOCALIDADE = 'LOCALIDADE',
  NACIONAL   = 'NACIONAL'
}
